import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';

import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-banner001',
  templateUrl: './banner001.component.html',
  styleUrls: ['./banner001.component.css']
})
export class Banner001Component implements OnInit {
  breakpoint; 

  constructor() { }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 800) ? 1 : 2;
  }
  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 800) ? 1 : 2;
  }

}
